import type { ReactNode } from 'react';
import { createElement, useEffect, useState } from 'react';

import { Space } from '@sravni/react-design-system';
import { useBehaviourState } from '@sravni/react-silent-authentication-form';

import { AUTH_SCREEN_NAME } from 'entities/Authentication/config/screenName';

import { AuthConsentsScreen } from './components/AuthConsentsScreen';
import { AuthInitialScreen } from './components/AuthInitialScreen';
import { AuthOtpScreen } from './components/AuthOtpScreen';

const SCREEN_MAPPING = {
  [AUTH_SCREEN_NAME.CONSENTS]: AuthConsentsScreen,
  [AUTH_SCREEN_NAME.INITIAL]: AuthInitialScreen,
  [AUTH_SCREEN_NAME.OTP]: AuthOtpScreen,
};

export function AuthenticationForm({ content }: { content: ReactNode }) {
  const { isOTPSended, isConsentsReceived, isLoading } = useBehaviourState();

  const [currentScreen, updateScreen] = useState<AUTH_SCREEN_NAME>(AUTH_SCREEN_NAME.INITIAL);

  useEffect(() => {
    if (typeof isConsentsReceived !== 'undefined' && isConsentsReceived === false) {
      updateScreen(AUTH_SCREEN_NAME.CONSENTS);
    } else if (isOTPSended) {
      updateScreen(AUTH_SCREEN_NAME.OTP);
    } else {
      updateScreen(AUTH_SCREEN_NAME.INITIAL);
    }
  }, [isLoading, isConsentsReceived, isOTPSended]);

  return (
    <Space direction="vertical" size={16}>
      {createElement(SCREEN_MAPPING[currentScreen], { content, updateScreen })}
    </Space>
  );
}
